// DOM-specific JS should be done here
// see /boilerplate/src/js/browser.js for the import pattern

import select from 'dom-select';
import { setCookie } from '../../../js/lib/cookies';

function GlobalAlert(el) {
  const ui = {
    el,
    dismissForm: select('.global-alert__dismiss', el),
    alertIdInput: select('input[name="alertCookieName"]', el),
    container: select('.global-alerts', document),
  };

  const dismissContainer = () => {
    if (ui.container) {
      ui.container
        .animate([
          { transform: 'scaleY(1)', transformOrigin: 'top' },
          { transform: 'scaleY(0)', transformOrigin: 'top' }
        ], { duration: 100, fill: 'forwards' })
        .onfinish = () => {
          ui.container.remove();
        };
    }
  }

  const getAlertCounts = () => {
    let totalAlertCount = select.all('.global-alert', ui.container).length;

    if (totalAlertCount === 0) {
      dismissContainer();
    }
  }

  const addEvents = () => {
    if (!ui.dismissForm) return;

    ui.dismissForm.addEventListener('submit', (e) => {
      e.preventDefault();

      const cookieName = ui.alertIdInput?.value;
      if (!cookieName) return;

      const alertTimestamp = ui.el.getAttribute('data-alert-timestamp');
      setCookie(cookieName, alertTimestamp, 30);

      const computedStyle = window.getComputedStyle(ui.el);
      const paddingTop = computedStyle.paddingTop;
      const paddingBottom = computedStyle.paddingBottom;

      const dismissAnimation = [
        { opacity: 1 },
        {
          opacity: 0,
          height: `${ui.el.scrollHeight}px`,
          paddingTop,
          paddingBottom,
        },
        { opacity: 0, height: '0', paddingTop: '0', paddingBottom: '0' },
      ];

      ui.el
        .animate(dismissAnimation, { duration: 250, fill: 'forwards' })
        .onfinish = () => {
          ui.el.remove();
          getAlertCounts();
        };
    });
  }

  const init = () => {
    addEvents();
  };

  init();
}

export default GlobalAlert;
